import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { initializeHeaderInfo } from "../../redux/action";
import { ArrowDownOutlined, CaretDownOutlined, DownOutlined, MenuOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { callMsGraph } from "../../utils/graph";
import { requestToken } from "../../auth/AuthServices";
import { Drawer, Button, Image, Menu, Dropdown, Space, Divider } from "antd";
import { PoweroffOutlined } from "@ant-design/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { Confirm } from "notiflix";
import { connect } from "react-redux";
import BrmLogo from "../../containers/home/asset/brm-logo.png";
import packageJson from "../../../package.json";
import "./styles.css";

import { Detector } from "react-detect-offline";

function Navbar(props) {
  const isAuthenticated = useIsAuthenticated();
  const { instance } = useMsal();
  const [drawerVisible, setDrawerVisible] = useState(false);

  function Logout() {
    Confirm.show(
      "Logout",
      "Are you sure want Logout Session?",
      "Yes",
      "No",
      () => {
        handleLogout(instance);
      },
      {}
    );
  }

  async function RequestToken() {
    try {
      const token = await requestToken(false);
      if (token) {
        const response_graph = await callMsGraph(token);
        props.setSession(response_graph);
      }
    } catch (e) {

    }
  }

  function handleLogout() {
    // Bersihin local storage / redux kalau perlu
    localStorage.clear();

    instance.logoutRedirect({
      postLogoutRedirectUri: "/",
    });
  }

  function dataCompany() {
    const sessionData = localStorage.getItem("session_signin");
    try {
      return sessionData ? JSON.parse(sessionData).company.fullname : "-";
    } catch {
      return "-";
    }
  }

  function codeCompany() {
    const sessionData = localStorage.getItem("session_signin");
    try {
      return sessionData ? JSON.parse(sessionData).company.code : "-";
    } catch {
      return "-";
    }
  }

  useEffect(() => {
    if (isAuthenticated) {
      const getSession = props.session ? props.session : {};
      if (
        Object.keys(getSession).length === 0 &&
        Object.getPrototypeOf(getSession) === Object.prototype
      ) {
        RequestToken();
      }
    }
  }, [isAuthenticated, props.session]);

  const showDrawer = () => {
    setDrawerVisible(true);
  };

  const closeDrawer = () => {
    setDrawerVisible(false);
  };

  const menu = (
    <Menu>
      <Menu.Item key="2" disabled={true}>
        <a>My Accounts</a>
      </Menu.Item>
      <Divider className="menu-account" />
      <Menu.Item key="1" onClick={Logout}>
        <a className="d-flex align-items-center">
          <PoweroffOutlined className="me-1" />
          Logout
        </a>
      </Menu.Item>
    </Menu>
  );
  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light">
        <div className="max-w-[1320px] mx-auto container">
          <div className="navbar__section">
            <div className="logo py-3">
              <Image
                preview={false}
                src={BrmLogo}
                width={48}
                alt="company logo"
              />
            </div>
          </div>

          {/* LEFT */}
          <ul className="navbar-nav me-auto align-items-center">
            <li className="nav-item">
              <a className="nav-link mx-1 px-1 font-bold" href="#">
                {dataCompany()}
              </a>
            </li>
          </ul>
          <div className="app-version-section-web font-medium d-none d-lg-flex">
            <span>Apps Version : {packageJson.version}</span>
          </div>
          <div className="d-flex align-items-center d-lg-none d-sm-flex">
            <Detector
              render={({ online }) => (
                <div
                  className="status-indicator"
                  style={{ marginRight: "30px" }}
                  title={online ? "Online" : "Offline Mode"}
                >
                  <span className={`status-ping ${online ? 'online' : ''}`} />
                  <span className={`status-dot ${online ? 'online' : 'offline'}`} />
                </div>
              )}
            />
          </div>

          {/* toggle */}
          <Button
            className="d-lg-none align-items-center"
            type="primary"
            icon={<MenuOutlined />}
            onClick={showDrawer}
          />

          {/* RIGHT */}
          <div className="d-flex align-items-center d-none d-lg-flex">
            <Detector
              render={({ online }) => (
                <div
                  className="status-indicator"
                  style={{ marginRight: "30px" }}
                  title={online ? "Online" : "Offline Mode"}
                >
                  <span className={`status-ping ${online ? 'online' : ''}`} />
                  <span className={`status-dot ${online ? 'online' : 'offline'}`} />
                </div>
              )}
            />
            <Dropdown overlay={menu} trigger={["click"]}>
              <div className="flex items-center gap-8 hover:bg-gray-100 cursor-pointer px-2 py-1">
                <div className="flex items-center gap-2">
                  <div className="flex flex-col">
                    <p className="text-gray-800 md:text-sm text-xs font-semibold line-clamp-1">
                      {props.session?.displayName || "User Name"}
                    </p>
                    <p className="md:text-xs font-medium text-[10px] text-secondary">{props.session?.userPrincipalName || "user@email.com"}</p>
                  </div>
                </div>
                <DownOutlined className="text-black text-primary-50" />
              </div>
            </Dropdown>
          </div>

          <Drawer
            title=""
            width={200}
            height={100}
            placement="right"
            onClose={closeDrawer}
            visible={drawerVisible}
          >
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <span style={{ fontSize: "14px" }}>{codeCompany()} </span>
              </li>
            </ul>
            <Divider
              style={{
                borderWidth: 2,
              }}
            />
            <div className="d-flex align-items-center">
              <Dropdown overlay={menu} trigger={["click"]}>
                <div className="profile-link">
                  <Space>
                    <div className="profile-section d-flex align-items-center">
                      <FontAwesomeIcon
                        icon={faUser}
                        className="profile-icon"
                        style={{ color: "#7b809a" }}
                      />
                      <div
                        className="mx-3"
                        style={{
                          fontSize: "10px",
                          // letterSpacing: "1px",
                        }}
                      >
                        {props.session?.displayName || "User Name"}
                        <br />
                        {props.session?.userPrincipalName || "user@email.com"}
                      </div>
                    </div>
                  </Space>
                </div>
              </Dropdown>
            </div>
            <div
              className="uinfo"
              style={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
              }}
              onClick={() => Logout()}
             />

            <div className="app-version-section my-3">
              <span>Apps Version : {packageJson.version}</span>
            </div>
          </Drawer>

          <div
            className="uinfo"
            style={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
            }}
            onClick={() => Logout()}
           />
        </div>
      </nav>
    </>
  );
}

const reduxState = (state) => ({
  session: state.session_info,
});

const reduxDispatch = (dispatch) => ({
  setSession: (data) => dispatch(initializeHeaderInfo(data)),
});

export default connect(reduxState, reduxDispatch)(Navbar);
